module.exports = __webpack_public_path__ + "media/Man_Chat_2.5833a97f.mp3";